/**
 * Read the data from the transfer.
 * @param transfer
 */
export function readData(transfer: DataTransfer | null): any {
    if (!transfer) {
        return null
    }

    const jsonData = transfer.getData("application/json");

    if (jsonData) {
        return JSON.parse(jsonData)
    }

    return transfer.getData("text/plain")
}

/**
 * Write the data into the transfer, with the appropiate conversions.
 * @param data
 * @param transfer
 */
export function writeData(data: any, transfer: DataTransfer): void {
    if ((typeof data) == "string") {
        transfer.setData("text/plain", data)
        transfer.setData("application/json", JSON.stringify(data))
        return
    }

    if (data == null || typeof data == "undefined") {
        return;
    }

    transfer.setData("text/plain", "" + data)
    transfer.setData("application/json", JSON.stringify(data))
}
